'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Extend = require('./util/extend');
var Logger = require('./util/logger');
var Url = require('./util/url');
var guid = require('./util/pageid');
var sdkVersion = require('./constant/version').version;
var protocol = require('./constant/protocol');
var EXT = ['region', 'operator', 'network', 'container', 'os', 'unionId'];
var urlProduct = protocol + '//catfront.dianping.com';
var urlBeta = protocol + '//catfront.51ping.com';

// 配置管理类

var CfgManager = function () {
    function CfgManager(config) {
        _classCallCheck(this, CfgManager);

        this._config = {
            devMode: false,
            project: '',
            pageUrl: '',
            webVersion: '',
            autoCatch: {
                page: true,
                ajax: true,
                fetch: false,
                resource: true,
                js: true,
                console: false,
                pv: true
            },
            page: {
                sample: 0.5,
                auto: true,
                sensoryIndex: true,
                disableSensoryImageIndex: true,
                interactToStopObserver: true,
                noCheckOuterMutaCount: false,
                fstPerfSample: 0.5,
                fstPerfAnalysis: false,
                logSlowView: false,
                delay: 0,
                logFirstScreen: false,
                ignoreIframe: true,
                mainResourceNumber: 5,
                timeThreshold: 5
            },
            SPA: {
                autoPV: false,
                getFST: false
            },
            resource: {
                sample: 0.1,
                sampleApi: 0.1,
                combo: true,
                delay: 1000,
                catchAbort: true,
                catchTimeout: false,
                enableStatusCheck: false,
                ignoreMTSIForbidRequest: true
            },
            resourceReg: /(.51ping|.dianping|.dpfile|.meituan|.sankuai|.kuxun|.maoyan|.neixin|.mobike|.dper.com)/,
            enableLogTrace: false,
            ajax: {
                invalid: true,
                flag: false,
                duration: 2000,
                autoBusinessCode: false,
                parseResponse: function parseResponse(res) {
                    if (!res || (typeof res === 'undefined' ? 'undefined' : _typeof(res)) !== 'object') return {};
                    return {
                        code: res.code || res.status
                    };
                }
            },
            invalid: {
                ajax: true
            },
            image: {
                flag: false,
                duration: 5000,
                fileSize: 100,
                filter: false
            },
            error: {
                sample: 1,
                delay: 1000,
                combo: false,
                maxSize: 1024 * 10,
                maxNum: 100,
                maxTime: 60 * 1000,
                formatUnhandledRejection: false
            },
            useSendBeacon: false,
            disableCache: true,
            noScriptError: true,
            metric: {
                sample: 0.5,
                combo: true,
                delay: 1500
            },
            logan: {
                enable: false
            },
            ignoreList: {
                js: ['Illegal invocation'],
                ajax: ['https?://report.meituan.com/', 'https?://logan.sankuai.com/'],
                resource: ['https?://hls.dianping.com/', 'https?://frep.meituan.net/']
            },
            disabledFilters: [],
            pageId: 'owl-' + guid()
        };
        this.baseQuery = {
            v: 1,
            sdk: sdkVersion
        };
        this.apiPaths = {
            log: '/api/log',
            error: '/api/log',
            page: '/api/speed',
            resource: '/batch',
            metric: '/api/metric',
            pv: '/api/pv',
            fstInfo: '/raptorapi/fstSpeed',
            fstLog: '/raptorapi/fstLog'
        };
        this.userConfig = {};
        this.config = {};
        this.extensions = {};
        this.filters = [];
        this.url = urlProduct;

        if (config) {
            this.set(config);
        } else {
            this.config = this._config;
        }
    }

    _createClass(CfgManager, [{
        key: 'get',
        value: function get(key) {
            return key ? this.config[key] : this.config;
        }
    }, {
        key: 'set',
        value: function set(data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    var val = data[key];
                    if (key === 'devMode') {
                        this.setApiDomain(val);
                        if (val) {
                            Logger.setDebug();
                        }
                    }
                    if (key === 'webVersion' && val) {
                        this.baseQuery['webVersion'] = val;
                    }
                    if (key === 'ext') {
                        this.setExtension(val);
                    }
                    if (key === 'resource' && val) {
                        val.sample = undefined;
                    }
                    try {
                        if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object' || val instanceof RegExp || val instanceof Array) {
                            this.userConfig[key] = key !== 'resourceReg' ? val : new RegExp(val);
                        } else if (key !== 'pageUrl') {
                            this.userConfig[key] = Extend(this.userConfig[key], val);
                        }
                    } catch (e) {
                        Logger.ignore(e);
                    }
                }
            }
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            this.config = this._config;
            for (var key in this.userConfig) {
                var data = this.userConfig[key];
                if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) != 'object' || data instanceof RegExp || data instanceof Array) {
                    this.config[key] = data;
                } else {
                    this.config[key] = Extend(this.config[key], this.userConfig[key]);
                }
            }
        }
    }, {
        key: 'setApiDomain',
        value: function setApiDomain(isDev) {
            this.url = isDev ? urlBeta : urlProduct;
        }
    }, {
        key: 'getExtension',
        value: function getExtension(key) {
            return key ? this.extensions[key] : this.extensions;
        }
    }, {
        key: 'setExtension',
        value: function setExtension(exts) {
            if (!exts) return;
            for (var key in exts) {
                if (exts.hasOwnProperty(key)) {
                    var value = exts[key];
                    if (key == 'latlng') {
                        // 修改url参数, 声明使用经纬度替换region
                        this.extensions['region'] = value;
                        this.baseQuery['useLatlng'] = true;
                    } else if (EXT.indexOf(key) > -1) {
                        this.extensions[key] = value;
                    }
                }
            }
        }
    }, {
        key: 'addFilter',
        value: function addFilter(key, fn) {
            if (key && fn instanceof Function && this.config.disabledFilters && this.config.disabledFilters.indexOf(key) === -1) {
                var filterIndex = -1;
                for (var i = 0; i < this.filters.length; i++) {
                    var filter = this.filters[i];
                    if (filter.key === key) {
                        filterIndex = i;
                        filter.fn = fn;
                        break;
                    }
                }
                if (filterIndex === -1) {
                    this.filters.push({ key: key, fn: fn });
                }
            }
        }
    }, {
        key: 'removeFilter',
        value: function removeFilter(key) {
            for (var i = 0; i < this.filters.length; i++) {
                var filter = this.filters[i];
                if (filter.key === key) {
                    this.filters.splice(i, 1);
                    return;
                }
            }
        }
    }, {
        key: 'getApiPath',
        value: function getApiPath(key) {
            var path = this.apiPaths[key];
            return Url.stringify(this.url + path, this.baseQuery);
        }
    }]);

    return CfgManager;
}();

module.exports = CfgManager;